import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { TemplatesTab } from '@/components/zalo/templates-tab'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/zalo/templates/',
)({
    component: TemplatesPage,
})

function TemplatesPage() {
    const navigate = useNavigate()
    return (
        <TemplatesTab
            onOpen={(id) =>
                void navigate({
                    to: '/settings/zalo/templates/$id',
                    params: { id },
                })
            }
        />
    )
}
